// extracted by mini-css-extract-plugin
export default {"container":"ScrollKeyword_container__1rFyH","text":"ScrollKeyword_text__GcEYQ","scrolled":"ScrollKeyword_scrolled__c540-"};